import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, fromEvent } from 'rxjs';
import { startWith } from 'rxjs';
import { AppLoginService } from '../app-login.service';
import { LocalService } from '@app/@core/services/local.service';

@Component({
  standalone: false,
  selector: 'app-ph-otp-verification',
  templateUrl: './ph-otp-verification.component.html',
  styleUrls: ['./ph-otp-verification.component.scss']
})
export class PhOtpVerificationComponent implements OnInit, OnDestroy{
  @ViewChild('otpFirst') otpFirstInput!: ElementRef;
  
  otp: string[] = ['', '', '', '', '', ''];
  timerActive = true;
  timeRemaining = 45;
  timerDisplay = '00:45';
  timerInterval: any;
  errorMessage = '';
  isResending: false;

  isMobile = false;
  logoPath = 'assets/images/edu-logo.svg';
  resizeObservable$: Subscription | undefined;

  constructor(private readonly router: Router, private readonly appLoginService: AppLoginService , private sessionStorage: LocalService,) {}

  ngOnInit(): void {
    this.startTimer();
    setTimeout(() => {
      if (this.otpFirstInput) {
        this.otpFirstInput.nativeElement.focus();
      }
    }, 0);
    this.setupResponsiveImage();

  }

  ngOnDestroy(): void {
    this.clearTimer();
     if (this.resizeObservable$) {
      this.resizeObservable$.unsubscribe();
    }
  }

  setupResponsiveImage(): void {

    this.resizeObservable$ = fromEvent(window, 'resize').pipe(startWith({} as Event))
      .subscribe(() => {
        this.isMobile = window.innerWidth < 768;
        this.updateLogoPath();
      });

    this.isMobile = window.innerWidth < 768;
    this.updateLogoPath();
  }

    updateLogoPath(): void {
    this.logoPath = this.isMobile 
      ? 'assets/images/cardy-ai/mobile-logo.svg'
      : 'assets/images/edu-logo.svg';
  }


  startTimer(): void {
    this.clearTimer();
    this.timerActive = true;
    this.timeRemaining = 45;
    this.updateTimerDisplay();
    
    this.timerInterval = setInterval(() => {
      this.timeRemaining--;
      this.updateTimerDisplay();
      
      if (this.timeRemaining <= 0) {
        this.clearTimer();
        this.timerActive = false;
        this.errorMessage = 'OTP expired. Please request a new verification code.';
      }
    }, 1000);
  }

  clearTimer(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  updateTimerDisplay(): void {
    const minutes = Math.floor(this.timeRemaining / 60);
    const seconds = this.timeRemaining % 60;
    this.timerDisplay = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  onOtpChange(index: number, event: Event): void {
    const input = event.target as HTMLInputElement;
    

    if (input.value) {
      const numericValue = input.value.replace(/\D/g, '');
      if (input.value !== numericValue) {
        input.value = numericValue;
        this.otp[index] = numericValue;
      }
    }
    

    if (input.value && index < 5) {
      const nextInput = input.parentElement?.children[index + 1] as HTMLInputElement;
      if (nextInput) {
        nextInput.focus();
      }
    }
  
    if (input.value === '' && index > 0) {
      const prevInput = input.parentElement?.children[index - 1] as HTMLInputElement;
      if (prevInput) {
        prevInput.focus();
      }
    }
  }

resendOtp(): void {
  this.otp = ['', '', '', '', '', ''];
  this.errorMessage = '';
  this.isResending = false;
  this.startTimer();

 
  const email = this.sessionStorage.getItem('recoveryEmail');
  console.log('Resending OTP to email:', email);
  if (email) {
    const request = { email };
    this.appLoginService.recoveryEmailVerification(request).subscribe({
      next: (response) => {
        console.log('Resend OTP successful:', response);


        if (this.otpFirstInput) {
          this.otpFirstInput.nativeElement.focus();
        }
      },
      error: (error) => {
        console.error('Error resending OTP:', error);
        this.errorMessage = 'Failed to resend OTP. Please try again.';
      }
    });
  } else {
    this.errorMessage = 'Email not found. Please go back and enter your email again.';
  }
}

  verifyOtp(): void {
    const otpValue = this.otp.join('');
    
    if (otpValue.length < 6) {
      this.errorMessage = 'Please enter the complete 6-digit verification code.';
      return;
    }

    this.errorMessage = '';
    
    console.log('OTP verification successful');
    this.router.navigate(['app-login/confirmation-screen']);
  }

  cancel(): void {
    this.router.navigate(['app-login/forgot-email']);
  }
  

  onlyNumeric(event: KeyboardEvent): boolean {
    // Use event.key instead of deprecated keyCode
    const key = event.key;
    const isNumber = /^\d$/.test(key);
    const isControlKey = event.ctrlKey || event.altKey || 
                         key === 'Tab' || 
                         key === 'Delete' || 
                         key === 'Backspace' ||
                         key === 'ArrowLeft' || 
                         key === 'ArrowRight' ||
                         key === 'Home' ||
                         key === 'End';
    
    if (!isNumber && !isControlKey) {
      event.preventDefault();
      return false;
    }
    return true;
  }

}
